import { render, staticRenderFns } from "./HappeningNowForm.vue?vue&type=template&id=631af79a"
import script from "./HappeningNowForm.vue?vue&type=script&lang=js"
export * from "./HappeningNowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports